import React from 'react';
import { styled } from '@mui/material/styles';
import withFeatureState from './state';

import { useAppContext } from 'components/v2/AppContext';
// mui
import List from './List';
import MuiDivider from '@mui/material/Divider';
import MuiListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';

// icons
import InboxIcon from '@mui/icons-material/MoveToInbox';
import DashboardIcon from '@mui/icons-material/Dashboard';

// paths
import { appBasePath, adminBasePath } from 'config/paths';
import { Organization, People, Profile, Settings, Insights } from './Sections';

const StyledListItem = styled(MuiListItem)({
  paddingTop: '0.75rem',
  paddingBottom: '0.75rem',
});

const Divider = styled(MuiDivider)({
  margin: '0',
});

const LoweredList = styled(List)({
  marginTop: 'auto',
});

const Component = ({ history, ...rest }) => {
  const { isAdminContext, isMyContext } = useAppContext();

  return (
    <>
      <List>
        <StyledListItem
          button
          {...{ onClick: () => history.push(isAdminContext ? adminBasePath : appBasePath) }}
        >
          <ListItemIcon>{isAdminContext ? <DashboardIcon /> : <InboxIcon />}</ListItemIcon>
          <ListItemText primary={isAdminContext ? 'Dashboard' : 'Home'} />
        </StyledListItem>
      </List>
      {isAdminContext && <People />}
      {isMyContext && <Profile />}
      {isAdminContext && <Organization />}
      {isAdminContext && <Insights />}

      <Divider />

      <LoweredList>
        <Divider />
        <Settings />
      </LoweredList>
    </>
  );
};

export default withFeatureState(Component);
